import React from "react";
import "./boqFooter.css";

export default function BOQFooter() {
  return (
    <div
      className="boqFooterContainer "
      style={{
        position: "absolute",
        bottom: 0,
        width: "94%"
      }}
    >
      <h2 className="thanksTag">THANK YOU FOR YOUR BUSINESS</h2>
      <div className="addressTag">
        BH Smith Office No: 13-A, G-Block, MA Johar Town, Lahore
      </div>
      <div className="boq-footer">
        <div className="tagsBox">
          <div className="icon-container">
            <img src='./images/assets/phone.png' width="14px" alt='Phone Icon' />
          </div>
          <span>042-32290262</span>
        </div>
        <div className="tagsBox">
          <div className="icon-container">
            <img src='./images/assets/email.png' width="16px" alt='Email Icon' />
          </div>
          <span>qasim@bhrenewable.com</span>
        </div>
        <div className="tagsBox">
          <div className="icon-container">
            <img src='./images/assets/globe.png' width="14px" alt='Globe Icon' />
          </div>
          <span>bhgroup.com.pk</span>
        </div>
      </div>
    </div>
  );
}
